import React from 'react'
import Button from './Button'
import { brandColor as DEFAULT_BRAND_COLOR } from '../../style/brandConfig'
import { useSelector } from 'react-redux'
import { selectBrandColor } from '../../store/base/commonSlice'
import { useNavigate } from 'react-router-dom'

type RegisterButtonProps = {
  redirectUrl?: string
}

const RegisterButton = ({ redirectUrl = '' }: RegisterButtonProps) => {
  const navigate = useNavigate()

  return (
    <Button
      text={'register'}
      backgroundColor={useSelector(selectBrandColor) || DEFAULT_BRAND_COLOR}
      width={110}
      height={39}
      onClick={() => navigate('/registration', { state: { redirectUrl } })}
    />
  )
}

export default RegisterButton
